// frontend/src/components/contacts/ContactsPage.jsx
import React, { useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import ContactList from "./ContactList";
import ContactForm from "./ContactForm";

const ContactsPage = () => {
  const { user } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState("list");
  const [selectedContact, setSelectedContact] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreate = () => {
    setSelectedContact(null);
    setActiveTab("form");
  };

  const handleEdit = (contact) => {
    setSelectedContact(contact);
    setActiveTab("form");
  };

  const handleSave = () => {
    setSelectedContact(null);
    setActiveTab("list");
    setRefreshKey((prev) => prev + 1);
  };

  const handleCancel = () => {
    setSelectedContact(null);
    setActiveTab("list");
  };

  return (
    <div className="container my-4">
      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-2 mb-md-3 gap-2">
        <h4 className="mb-0 h5">
          <i className="bi bi-building me-2"></i>
          Contacts
        </h4>
      </div>

      {/* Info Card */}
      <div className="alert alert-info mb-2 mb-md-3 py-2 small">
        <i className="bi bi-info-circle me-2"></i>
        <strong>Employer Contacts:</strong> Manage your community employer contacts 
        for job placement services. <span className="d-none d-md-inline">These contacts are shared across all job coaches 
        and can be used when tracking job search activities and placements.</span>
      </div>

      {/* Navigation Tabs */}
      <ul className="nav nav-tabs flex-nowrap overflow-auto mb-2 mb-md-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "list" ? "active" : ""}`}
            onClick={() => {
              setSelectedContact(null);
              setActiveTab("list");
            }}
          >
            <i className="bi bi-list-ul me-1 me-sm-2"></i>
            <span className="d-none d-sm-inline">All </span>Contacts
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "form" ? "active" : ""}`}
            onClick={handleCreate}
          >
            <i className="bi bi-plus-circle me-1 me-sm-2"></i>
            {selectedContact ? "Edit" : "Add"}<span className="d-none d-sm-inline"> Contact</span>
          </button>
        </li>
      </ul>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === "list" && (
          <ContactList
            key={refreshKey}
            onEdit={handleEdit}
            onCreate={handleCreate}
          />
        )}

        {activeTab === "form" && (
          <ContactForm
            contact={selectedContact}
            onSave={handleSave}
            onCancel={handleCancel}
          />
        )}
      </div>
    </div>
  );
};

export default ContactsPage;